G.OneLineText = function(x,y,font,text,size,width,hAnchor,vAnchor) {  

  Phaser.BitmapText.call(this, game, G.l(x), G.l(y), font, text, G.l(size), G.l(width));

  if (width) {
      while (this.width > G.l(width)) {
        this.fontSize -= 2;
        this.updateText();
        if (this.fontSize < 5) break;
      }
  }


  this.orgFontSize = G.l(size);

  this.maxUserWidth = G.l(width);

  
  this.skipCaching = G.skipOneLineTextCaching || false;

  this.hAnchor = hAnchor;
  this.vAnchor = vAnchor;

  this.anchor.setTo(this.hAnchor,this.vAnchor);
  this.updateText();


  this.insertCoin(this.fontSize);

  if (!this.skipCaching) {
    this.cacheAsBitmap = true;
    this.updateCache();
  }

  

  //this._cachedSprite.anchor.setTo(typeof this.hAnchor == 'undefined' ? 0.5 : this.hAnchor,this.vAnchor || 0);

  //this.x -= Math.floor(this.width*0.5);


};


G.OneLineText.prototype = Object.create(Phaser.BitmapText.prototype);
G.OneLineText.prototype.constructor = G.OneLineText;

G.OneLineText.prototype.insertCoin = function(size) {


  if (this.text.indexOf('$$') == -1) return;


  this.children.forEach(function(element,index,array) {

    if (!element.name) return;

    if (element.name == "$" && element.visible) {
      if (index+1 <= array.length-1 && array[index].name == '$') {

        var el = element;
        var el2 = array[index+1];

        el.visible = false;
        el2.visible = false;
        coin = G.makeImage(el.x+(size*0.05),el.y-(size*0.05),'coin');
        coin.width = size;
        coin.height = size;
        el.parent.addChild(coin);


      }
    }


  });

} 


G.OneLineText.prototype.setText = function(text) {

  Phaser.BitmapText.prototype.setText.call(this,text.toString());

  var oldScaleX = this.scale.x;
  var oldScaleY = this.scale.y;
  var oldAlpha = this.alpha;
  var oldAngle = this.angle;

  this.alpha = 1;
  this.scale.setTo(1);


  if (this.maxUserWidth) {
    this.fontSize = this.orgFontSize;
    this.updateText();
    var i = 0;
    while (this.width > this.maxUserWidth) {
      this.fontSize -= 1;

      this.updateText();
      if (this.fontSize < 5) break;
    }
  }

  if (!this.skipCaching && this.cacheAsBitmap) this.updateCache();

  this.scale.setTo(oldScaleX,oldScaleY);
  this.alpha = oldAlpha;
  this.angle = oldAngle;
  //this._cachedSprite.anchor.setTo(this.hAnchor || 0.5,1);

};


G.OneLineText.prototype.popUpAnimation = function() {
  
  this.cacheAsBitmap = false;

  var char_numb = this.children.length;
 
  //
  var delay_array = [];
  for (var i = 0; i < char_numb; i++) {
    delay_array[i] = i;
  }
 
  delay_array = Phaser.ArrayUtils.shuffle(delay_array);
  delay_index = 0;
  this.activeTweens = 0;

  this.children.forEach(function(letter) {
 
      if (letter.anchor.x == 0) {
        letter.x = letter.x + (letter.width*0.5);
        letter.y = letter.y + letter.height;
        letter.anchor.setTo(0.5,1);
      }
      var target_scale = letter.scale.x;
      letter.scale.setTo(0,0);
      this.activeTweens++;
      var tween = game.add.tween(letter.scale)
        .to({x:target_scale*1.5,y:target_scale*1.5},200,Phaser.Easing.Quadratic.In,false,delay_array[delay_index]*25)
        .to({x:target_scale,y:target_scale},200,Phaser.Easing.Sinusoidal.In);
      tween.onComplete.add(function() {this.activeTweens--; if (this.activeTweens == 0) {if (this.alive && !this.skipCaching) this.cacheAsBitmap = true;}},this);
      tween.start();
      delay_index++; 
    },this)
};

G.OneLineText.prototype.scaleOut = function(onComplete,context) {
  this.cacheAsBitmap = false;

  this.activeTweens = 0;


  this.children.forEach(function(letter,index) {

      if (letter.anchor.x == 0) {
        letter.x = letter.x + letter.width*0.5;
        letter.y = letter.y + letter.height*0.5;
        letter.anchor.setTo(0.5,0.5);
      }
      this.activeTweens++;
      letter.scale.setTo(letter.scale.x,letter.scale.y);

      var tween = game.add.tween(letter.scale)
        .to({x:0,y:0},400,Phaser.Easing.Cubic.In,false,index*20);
      tween.onComplete.add(function() {
        this.activeTweens--;
        if (this.activeTweens == 0) {this.destroy()}
       },this);
      tween.start();
    },this)

}





G.OneLineCounter = function(x,y,font,amount,size,width,hAnchor,vAnchor,preText,postText) {
  
  G.OneLineText.call(this,x,y,font,'',size,width,hAnchor,vAnchor);

  this.amount = amount;
  this.amountDisplayed = amount;
  this.amountMaxInterval = 5;
  this.amountMaxNegInterval = -5;

  this.absoluteDisplay = false;
  this.fixedToDecimal = 0;

  this.stepCurrent = 0;
  this.step = 0;

  this.preText = preText || '';
  this.postText = postText || '';

  this.setText(this.preText+amount+this.postText);

};

G.OneLineCounter.prototype = Object.create(G.OneLineText.prototype);

G.OneLineCounter.prototype.update = function() {

  if (this.lerp){
    this.lerpUpdate();
    return;
  }
  
  if (this.amountDisplayed != this.amount && this.stepCurrent-- <= 0) {
    this.stepCurrent = this.step;
  
    if (this.amountDisplayed != this.amount) {

      var diff = this.amount - this.amountDisplayed;

      this.amountDisplayed += game.math.clamp(diff,this.amountMaxNegInterval,this.amountMaxInterval);


      var valueToDisplay = this.amountDisplayed;

      if (this.absoluteDisplay) {valueToDisplay = Math.abs(valueToDisplay)};
      if (this.fixedTo != 0) {valueToDisplay = valueToDisplay.toFixed(this.fixedToDecimal)};

      this.setText(this.preText+valueToDisplay+this.postText);

    } 

  }

};

G.OneLineCounter.prototype.changeAmount = function(amount) {
  this.amount = amount;
};

G.OneLineCounter.prototype.increaseAmount = function(change) {
  this.amount += change;
};

G.OneLineCounter.prototype.changeIntervals = function(max,maxNeg) {

  if (typeof maxNeg == 'undefined') {
    this.amountMaxInterval = max;
    this.amountMaxNegInterval = -max;
  }else {
    this.amountMaxInterval = max;
    this.amountMaxNegInterval = maxNeg;
  }

} 

G.OneLineCounter.prototype.lerpUpdate = function(){

  if (this.amountDisplayed != this.amount && this.stepCurrent-- <= 0){
    this.stepCurrent = this.step;
    this.amountDisplayed = Math.round(G.lerp(this.amountDisplayed,this.amount,0.5,0.6));
    this.setText(this.amountDisplayed.toString());

  }

};